export { default } from './normalizeWheel.js';
